import { productAccessorVariantsNotForSale } from '../../../model/productAccessor/productAccessorVariantsNotForSale'
import { PRODUCT_TEMPLATES } from '../../../model/productTemplates'
import { useProductPageContext } from '../../productPageContext'

export const useProductCrossSellOutOfStockWidget = (): boolean => {
  const { followUpProduct, product, productTemplate } = useProductPageContext()

  if (productTemplate === PRODUCT_TEMPLATES.RX) {
    return false
  }

  return (
    !followUpProduct?.canonical_url &&
    productAccessorVariantsNotForSale(product)
  )
}
